import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { Voucher } from 'src/features/vouchers/utils/types';
import { VoucherFormSchemaValues } from 'src/features/vouchers/utils/formSchema';

const RESOURCE = '/discounts/voucher/:voucherId/';

type MutationFnType = typeof mutationFn;

interface DTO extends VoucherFormSchemaValues {
    voucherId: string;
}
const mutationFn = ({ voucherId, ...data }: DTO): Promise<Voucher> => {
    return axios.put(formatResourcePath(RESOURCE, { voucherId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateVoucher };
